import React from 'react';
import { QuestionRendererProps } from './QuestionRenderer';

const RatingRenderer: React.FC<Omit<QuestionRendererProps, 'questionNumber'>> = ({
  question,
  value,
  onChange,
  error,
}) => {
  const maxRating = question.settings?.maxValue || 5;
  const scaleLabels = question.settings?.scaleLabels || [];

  const handleClick = (rating: number) => {
    onChange(rating);
  };

  return (
    <div>
      <div className="flex items-center space-x-2">
        {Array.from({ length: maxRating }, (_, index) => {
          const rating = index + 1;
          const isSelected = value === rating;
          const isHovered = value && rating <= value;

          return (
            <button
              key={rating}
              type="button"
              onClick={() => handleClick(rating)}
              className={`text-4xl transition-all transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded ${
                error ? 'text-red-300' : ''
              }`}
              aria-label={`Rate ${rating} out of ${maxRating} stars`}
              aria-pressed={isSelected}
            >
              <span className={isSelected || isHovered ? 'text-yellow-400' : 'text-gray-300'}>
                ⭐
              </span>
            </button>
          );
        })}
        {value && (
          <span className="ml-4 text-gray-700 font-medium">{value} / {maxRating}</span>
        )}
      </div>

      {/* Rating labels */}
      {scaleLabels.length > 0 && (
        <div className="flex justify-between mt-2 text-sm text-gray-600">
          <span>{scaleLabels[0] || ''}</span>
          <span>{scaleLabels[scaleLabels.length - 1] || ''}</span>
        </div>
      )}
    </div>
  );
};

export default RatingRenderer;
